import { getSingleChoiceValue } from '@r-and-a-shared-ui/common-kontent-client/utils';

import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export const player_portals_id_card = (entry: PLAYER_PORTALS_MODELS.IDCard) => {
  if (!entry || !entry?.elements) {
    return undefined;
  }
  const { elements } = entry;

  return {
    greetingMessage: elements?.greeting_message?.value,
    playerLabel: elements?.player_label?.value,
    managerLabel: elements?.manager_label?.value,
    caddieLabel: elements?.caddie_label?.value,
    playersNrLabel: elements?.players_number_label?.value,
    theme: getSingleChoiceValue(elements?.theme),
    roles: elements.roles?.value || [],
  };
};

export default player_portals_id_card;
